export default [
	{
		path: "/",
		name: "user.home",
		component: () => import("@/resources/user/home"),
	},
	{
		path: "about",
		name: "user.about",
		component: () => import("@/resources/user/about"),
	},
	{
		path: "admission",
		name: "user.admission",
		component: () => import("@/resources/user/admission"),
	},
	{
		path: "cooperation",
		name: "user.cooperation",
		component: () => import("@/resources/user/cooperation"),
	},
	{
		path: "news",
		name: "user.news",
		component: () => import("@/resources/user/news"),
		redirect: {
			name: "user.news.list",
		},
		children: [
			{
				path: "list",
				name: "user.news.list",
				component: () => import("@/resources/user/news/list"),
			},
			{
				path: "detail/:id",
				name: "user.news.detail",
				component: () => import("@/resources/user/news/detail"),
			},
		],
	},
	{
		path: "recruitment",
		name: "user.recruitment",
		component: () => import("@/resources/user/recruitment"),
	},
	{
		path: "student-life",
		name: "user.student-life",
		component: () => import("@/resources/user/student-life"),
	},
	{
		path: "training",
		name: "user.training",
		component: () => import("@/resources/user/training"),
		redirect: {
			name: "user.training.list",
		},
		children: [
			{
				path: "list",
				name: "user.training.list",
				component: () => import("@/resources/user/training/list"),
			},
			{
				path: "detail/:id",
				name: "user.training.detail",
				component: () => import("@/resources/user/training/detail"),
			},
		],
	},
	{
		path: "contact",
		name: "user.contact",
		component: () => import("@/resources/user/contact"),
	},
];
